module.exports = __webpack_public_path__ + "static/media/qrcode.75e17021.svg";